import { apiV2, errorHandler } from "./index";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { API_ERROR, FETCH_ALL_CATEGORIES, CLEAR_HIGHLIGHT, FETCH_ONE_CATEGORY } from "../constants/ActionTypes";

//= ===============================
// Category actions
//= ===============================

export function fetchAllCategories(isQuickTap = null) {
  return function (dispatch) {
    const params = {};
    if (isQuickTap !== null) {
      params.is_quick_tap = isQuickTap;
    }

    apiV2.get('/categories', { params })
      .then((response) => {
        dispatch({
          type: FETCH_ALL_CATEGORIES,
          payload: response.data.objects || [],
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function clearCategories() {
  return function (dispatch) {
    dispatch({
      type: FETCH_ALL_CATEGORIES,
      payload: null,
    });
  };
}

export function addEditCategory(options) {
  return function (dispatch) {
    const categoryData = typeof options.category_json === 'string'
      ? JSON.parse(options.category_json)
      : options.category_json;

    const childObjects = options.child_objects_json
      ? (typeof options.child_objects_json === 'string'
        ? JSON.parse(options.child_objects_json)
        : options.child_objects_json)
      : undefined;

    const isUpdate = !!categoryData.category_id;

    const payload = {
      category_title: categoryData.category_title,
      category_description: categoryData.category_description,
      category_explore_term: categoryData.category_explore_term,
      category_image: categoryData.category_image,
      category_is_active: categoryData.category_is_active,
      category_is_dark_mode: categoryData.category_is_dark_mode,
      category_is_select_interest: categoryData.category_is_select_interest,
      category_is_quick_tap: categoryData.category_is_quick_tap,
      category_deep_link_image: categoryData.category_deep_link_image,
      category_deep_link_android: categoryData.category_deep_link_android,
      category_deep_link_ios: categoryData.category_deep_link_ios,
    };

    if (isUpdate && childObjects) {
      payload.child_objects = childObjects;
    }

    const request = isUpdate
      ? apiV2.put(`/categories/${categoryData.category_id}`, payload)
      : apiV2.post('/categories', payload);

    return request
      .then((response) => {
        // After create/update, re-fetch the list to keep Redux in sync
        fetchAllCategories()(dispatch);

        if (isUpdate) {
          // For updates, re-fetch the single category
          fetchOneCategory(categoryData.category_id)(dispatch);
        } else if (response.data) {
          dispatch({
            type: FETCH_ONE_CATEGORY,
            payload: response.data
          });
        }

        return response;
      });
  };
}

export function deleteCategory(category_id, onSuccess) {
  return function (dispatch) {
    apiV2.delete(`/categories/${category_id}`)
      .then(() => {
        dispatch({
          type: 'DELETE_CATEGORY',
          payload: category_id
        });

        Swal.fire({
          icon: "success",
          title: "Category Deleted!",
          timer: 1000,
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function sortCategories(category_ids) {
  return function (dispatch) {
    apiV2.patch('/categories/sort', { data: category_ids })
      .then(() => {
        dispatch({
          type: CLEAR_HIGHLIGHT,
          payload: null
        });
      })
      .catch((error) => {
        dispatch({
          type: CLEAR_HIGHLIGHT,
          payload: null
        });
        fetchAllCategories()(dispatch);
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function fetchOneCategory(category_id) {
  return function (dispatch) {
    apiV2.get(`/categories/${category_id}`)
      .then((response) => {
        dispatch({
          type: FETCH_ONE_CATEGORY,
          payload: response.data,
        });
      })
      .catch((error) => {
        console.error('fetchOneCategory - Error:', error);
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}
